@if (!commonDataService.isOneTime && !commonDataService.user.isReadOnly) {
    @for (tag of tags; track tag.id; let last = $last) {
        <a
            class="label label-link label-sm mb-1 mt-1 d-inline-block truncate"
            [class.me-1]="!last"
            [routerLink]="['/', commonDataService.communityName, 'tickets']"
            [queryParams]="{ ticketId: ticketId, tagIds: tag.id }"
            container="body"
            tooltip="{{ 'Click to view all tickets with such tag' | translate }}">
            <span [innerHTML]="tag.text | replaceEmojis: false : true"></span>
        </a>
    }
} @else {
    @for (tag of tags; track tag.id; let last = $last) {
        <span
            class="label label-sm mb-1 mt-1 d-inline-block truncate"
            [class.me-1]="!last"
            [innerHTML]="tag.text | replaceEmojis: false : true">
        </span>
    }
}
